import { EventBusForThirdParty } from '../event-bus'
import { handlePublishDeveloperReports } from './default/handle-publish-developer-reports'
import { EventSubscriptionFacade } from './facade'
import { handleAddToCart } from './ledian/handle-add-to-cart'
import { handleAddToFavorite } from './ledian/handle-add-to-favorite'
import { handleEveryPageView } from './ledian/handle-every-page-view'
import { handleItemDetailView } from './ledian/handle-item-detail-view'
import { handleLogIn } from './ledian/handle-login'
import { handlePurchase } from './ledian/handle-purchase'
import { handleSignUp } from './ledian/handle-signup'
import { handleSubscribeMembershipPlan } from './ledian/handle-subscribe-membership-plan'
import { handleCartViewEvent } from './shared/handle-cart-detail-view'
import { handleProductDetailViewEvent } from './shared/handle-product-detail-view'

export class LedianEventSubscriptionFacade implements EventSubscriptionFacade {
  constructor() {
    /** GAで使用するdataLayerがundefinedでないことを保証する。 */
    window.dataLayer = window.dataLayer || []
  }

  subscribeAll(): void {
    const eventBus = EventBusForThirdParty.getInstance()
    eventBus.subscribe('signup', handleSignUp)
    eventBus.subscribe('every-page-view', handleEveryPageView)
    /**
     * TODO
     * item-detail-viewで必要な情報はproduct-detail-viewに含まれるようになったので
     * - item-detail-viewのsubscribeはやめてproduct-detail-viewを購読してhandleItemDetailViewと同じ処理を行うようにする
     * - それによってitem-detail-view廃止できるはずなのでイベントごと削除する
     * @see https://github.com/Everforth/growthpalette-front/pull/8277#issuecomment-2618391780
     */
    eventBus.subscribe('item-detail-view', handleItemDetailView)
    eventBus.subscribe('product-detail-view', handleProductDetailViewEvent)
    eventBus.subscribe('cart-view', handleCartViewEvent)
    eventBus.subscribe('login', handleLogIn)
    eventBus.subscribe('add-to-favorite', handleAddToFavorite)
    eventBus.subscribe('add-to-cart', handleAddToCart)
    eventBus.subscribe('purchase', handlePurchase)
    eventBus.subscribe('subscribe-membership-plan', handleSubscribeMembershipPlan)
    eventBus.subscribe('publish-developer-reports', handlePublishDeveloperReports)
  }
}
